import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy text-brand-white pt-16 pb-8" data-id="element-9">
      <div className="container mx-auto px-4 md:px-6" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-12 text-center md:text-left" data-id="element-11">
          {/* Column 1: Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-12">
            <div className="bg-brand-white p-4 rounded-2xl inline-block" data-id="element-13">
              <img src="https://cdn.magicpatterns.com/uploads/gtD1cnnHQnJHdEWphpETGZ/deep-clean-logo.png" alt="Deep Clean Cleaners Mascot" className="h-24 w-auto object-contain" data-id="element-14" />
            </div>
            <p className="text-brand-sky font-medium text-lg mt-2" data-id="element-15">
              Committed to Cleanliness.
            </p>
            <div className="flex gap-4 mt-4 justify-center md:justify-start" data-id="element-16">
              <a href="#" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-17">
                <Facebook className="h-6 w-6" data-id="element-18" />
                <span className="sr-only" data-id="element-19">Facebook</span>
              </a>
              <a href="#" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-20">
                <Instagram className="h-6 w-6" data-id="element-21" />
                <span className="sr-only" data-id="element-22">Instagram</span>
              </a>
              <a href="#" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-23">
                <Twitter className="h-6 w-6" data-id="element-24" />
                <span className="sr-only" data-id="element-25">Twitter</span>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col gap-4" data-id="element-26">
            <h3 className="font-display font-bold text-xl mb-2" data-id="element-27">Quick Links</h3>
            <nav className="flex flex-col gap-3" data-id="element-28">
              <a href="#" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-29">
                Home
              </a>
              <a href="#services" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-30">
                Services
              </a>
              <a href="#about" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-31">
                About
              </a>
              <a href="#contact" className="text-brand-sky hover:text-brand-white transition-colors" data-id="element-32">
                Contact
              </a>
            </nav>
          </div>

          {/* Column 3: Contact */}
          <div className="flex flex-col gap-4" data-id="element-33">
            <h3 className="font-display font-bold text-xl mb-2" data-id="element-34">Contact</h3>
            <div className="flex flex-col gap-3 text-brand-sky" data-id="element-35">
              <a href="mailto:info@deepcleancleaners.com" className="hover:text-brand-white transition-colors" data-id="element-36">
                info@deepcleancleaners.com
              </a>
              <a href="tel:4637772838" className="hover:text-brand-white transition-colors" data-id="element-37">
                (463) 777-2838
              </a>
              <p className="mt-2 font-medium text-brand-white" data-id="element-38">
                Available 24/7.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brand-sky/20 pt-8 text-center" data-id="element-39">
          <p className="text-brand-sky text-sm" data-id="element-40">
            © 2026 Deep Clean Cleaners. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}